import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'

export const sendConsent = (communityId, consent) => {
  if (consent.type && consent.value !== undefined) {
    const url: string = AjaxWrapper.getServerUrl() + `/acceptance/${communityId}`
    AjaxWrapper.ajax(url, HttpMethod.POST, consent)
  }
}
